var map = {
	"./excel.svg": "8a4b",
	"./file.svg": "a273",
	"./folder.svg": "77bd",
	"./image.svg": "f2d6",
	"./other.svg": "9cbd",
	"./pdf.svg": "df87",
	"./pdf_02.svg": "a91b",
	"./pdf_03.svg": "b3b3",
	"./powerpoint.svg": "0cc5",
	"./video.svg": "215b",
	"./word.svg": "521f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0b25e";